import { useContext } from "react";

import { matchPath, Routes } from "react-router";

import useResizeObserver from "use-resize-observer";

import MaintenanceBanner from "components/MaintenanceBanner";
import AuthContext from "context/auth/authContext";
import { useGoogleAnalytics } from "shared/hooks/useGoogleAnalytics";
import { useHotjar } from "shared/hooks/useHotjar";
import { useWindowLocation } from "shared/hooks/useWindowLocation";
import { ROUTES } from "shared/types/enums";

import Navbar from "../Navbar";
import CookiesBanner from "../Privacy/Cookies/CookiesBanner";
import Snackbar from "../Snackbar";
import TutorialMode from "../TutorialMode";
import { useRoutes } from "./hooks";

const RouterContent = () => {
    const { is2FaEnableFlowSeen, isAuthenticated, user } =
        useContext(AuthContext);

    useGoogleAnalytics();
    useHotjar();

    const { renderRoutes } = useRoutes();
    const { pathname } = useWindowLocation();
    const { ref: bannerRef, height: bannerHeight = 0 } =
        useResizeObserver<HTMLElement>();

    const isSignUpRoute = matchPath(ROUTES.Signup, pathname) !== null;
    const isResetRoute =
        pathname === ROUTES.Reset || pathname === ROUTES.RequestReset;
    const isMaintenanceRoute = pathname === ROUTES.Maintenance;
    const isErrorRoute = pathname === ROUTES.Error;

    const isNotPrivateRoute =
        !isSignUpRoute && !isResetRoute && !isMaintenanceRoute && !isErrorRoute;

    const isAllowedToSeeContent = user !== null && is2FaEnableFlowSeen;
    const renderNavbar = isNotPrivateRoute && isAllowedToSeeContent;

    return (
        <>
            {isAllowedToSeeContent && <TutorialMode />}

            <div ref={bannerRef}>
                <MaintenanceBanner />
            </div>

            {renderNavbar && <Navbar bannerHeight={bannerHeight} />}

            <Routes>{renderRoutes()}</Routes>

            {(!isAuthenticated || is2FaEnableFlowSeen) && <CookiesBanner />}

            <Snackbar />
        </>
    );
};

export default RouterContent;
